interface ColorClasses {
    bg: string;
    text: string;
    icon: string;
}

const statusColors: Record<string, ColorClasses> = {
    success: { bg: 'bg-status-success-subtle', text: 'text-status-success-foreground', icon: 'text-status-success' },
    warning: { bg: 'bg-status-warning-subtle', text: 'text-status-warning-foreground', icon: 'text-status-warning' },
    danger:  { bg: 'bg-status-danger-subtle',  text: 'text-status-danger-foreground',  icon: 'text-status-danger' },
    info:    { bg: 'bg-status-info-subtle',    text: 'text-status-info-foreground',    icon: 'text-status-info' },
    neutral: { bg: 'bg-status-neutral-subtle', text: 'text-status-neutral-foreground', icon: 'text-status-neutral' },
};

const paletteColors: Record<string, ColorClasses> = Object.fromEntries(
    Array.from({ length: 13 }, (_, i) => {
        const n = i + 1;
        return [`palette-${n}`, {
            bg: `bg-palette-${n}-subtle`,
            text: `text-palette-${n}-fg`,
            icon: `text-palette-${n}`,
        }];
    }),
);

const colorClassMap: Record<string, ColorClasses> = {
    ...statusColors,
    ...paletteColors,
};

export function getColorClasses(semantic: string): ColorClasses {
    return colorClassMap[semantic] ?? colorClassMap.neutral;
}

export function getBadgeClasses(semantic: string): string {
    const c = getColorClasses(semantic);
    return `${c.bg} ${c.text}`;
}
